import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { h4, graphTitle } from '@/styles/typography'
import { Link } from 'gatsby'

import { StaticImage } from 'gatsby-plugin-image'

import Eye from '@/images/vectors/icon-more.svg'
import Sharer from '@/components/UI/Sharer'

const normal = css`
  color: black;
  background-color: white;
`

const inverted = css`
  color: white;
  background-color: black;
  h2 {
    will-change: text-shadow, color;
    transition: text-shadow 0.3s ease-in-out;
    transition-delay: 0.3s;
    text-shadow: 6px 6px 0 rgba(0, 0, 0, 0.5);
  }
`

const Container = styled.div`
  ${props => (props.odd ? inverted : normal)}
  align-items: center;
  z-index: 3;
  position: relative;
  z-index: 2;
  will-change: color, background-color;
  transition: all 0.2s;
  > * {
    transition: all 0.2s;
  }
  &:hover {
    ${props => (props.odd ? normal : inverted)}
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.4rem;
    > div {
      &:first-of-type {
        order: 2;
      }
    }
  }
`

const Content = styled.div`
  padding: 8rem 4rem 0;
  position: relative;
  z-index: 2;
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  @media (max-width: 768px) {
    padding: 2rem 2rem 0;
    max-width: 100%;
  }
  h2 {
    ${h4};
    font-family: 'Work Sans', Arial, Helvetica, sans-serif;
    font-weight: bold;
    margin-bottom: 2rem;
  }
  .excerpt {
    p {
      ${graphTitle};
    }
  }
`

const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  .gatsby-image-wrapper {
    min-height: 100vh;
    height: 100%;
    display: block;
  }
  .desktop {
    display: block;
    height: 100%;
    @media (max-width: 768px) {
      display: none;
    }
  }
  .mobile {
    display: none;
    height: 100%;
    @media (max-width: 768px) {
      display: block;
    }
  }
`

const ArticleCard = ({
  title,
  type = 'article',
  excerpt,
  slug,
  featuredImage,
  odd,
  index,
}) => {
  return (
    <Container>
      <Content>
        <Sharer
          url={`https://especiales.latercera.com/100-anos-de-la-insulina/`}
          title="100 años de la insulina - Especiales La Tercera - Presentado por Novo Nordisk"
          comparte="  "
          hashtags="insulina100años"
          via="latercera"
        />
        <Link to={`/${slug}/`}>
          <h2>{title}</h2>
        </Link>
        <Link to={`/${slug}/`}>
          <div
            className="excerpt"
            dangerouslySetInnerHTML={{ __html: excerpt }}></div>
        </Link>
        <Link to={`/${slug}/`}>
          <span className="inline-block px-4 py-2 mt-4">
            <Eye />
            <i>ver más</i>
          </span>
        </Link>
      </Content>
      <Bg>
        {index === 0 && (
          <>
            <div className="mobile">
              <StaticImage alt="" src="./nota2-mobile.jpg" />
            </div>
            <div className="desktop">
              <StaticImage alt="" src="./nota2.jpg" />
            </div>
          </>
        )}
        {index === 1 && (
          <>
            <div className="mobile">
              <StaticImage alt="" src="./nota3-mobile.jpg" />
            </div>
            <div className="desktop">
              <StaticImage alt="" src="./nota3.jpg" />
            </div>
          </>
        )}
      </Bg>
    </Container>
  )
}

export default ArticleCard
